import React from 'react'

import { View, StyleSheet, Linking, ScrollView } from 'react-native'

import { useClient, client } from '@sart/client'
import { useContent } from '@sart/content'
import { adaptive, colors, backgroundColors, typography } from '@sart/styles'

import { Select, Button, Space, MenuList, Text } from '@sart/components'
import { LanguageIconType } from '@sart/icons'
import { testID } from '@sart/utilities'

export default function GiftSwapMenu(props) {
  const content = useContent()

  const { navigation } = props

  const { cache } = useClient()

  function handleRouting(item) {
    if (item.link) {
      return Linking.openURL(item.link)
    }
    navigation.navigate(item.id)
  }

  const menuItems = [
    {id: 'Transfer', label: content.menu.giftLabel },
    {id: 'Transform', label: content.menu.swapLabel },
  ]

  return (
    <ScrollView style={styles.wrapper} createContainerStyle={styles.container}>
      <Text style={styles.description}>{content.menu.giftSwapDescription}</Text>
      {/* <MenuList color={colors.srGreen} style={styles.menuStyle}>
        {
          menuItems.map(item =>
            <MenuList.Item
              key={item.id}
              label={item.label}
              onPress={() => handleRouting(item)}
              style={styles.menuListItemStyle}
              {...testID(item.id)}
            />
          )
        }
      </MenuList> */}

      <Space height={40} />
    </ScrollView>
  )
}

const styles = StyleSheet.create({
  container: {

  },
  wrapper: {
    flex: 1,
    ...adaptive.menuPaddingTop,
    paddingBottom: 24,
    ...adaptive.wrapperPadding,
    // paddingTop: '50%',
  },
  selectStyle: {
    borderWidth: 1,
    backgroundColor: backgroundColors.feature,
    color: colors.srGreen,
    borderColor: colors.srGreen,
    borderRadius: 4
  },
  logoutButtonStyle: {
    backgroundColor: colors.srDarkGreen
  },
  flagIcon: {
    alignSelf: 'center',
    position:'absolute',
    right:'15%',
    bottom:'30%'
  },
  menuListItemStyle: {
    color: colors.srTextInput,
    ...typography.lightbold,
  },
  labelStyles: {
    ...typography.demi
  },
  inputStyles: {
    ...typography.medium
  },
  spaceHeight: {
    ...adaptive.menuSpaceHeight
  },
  menuStyle: {
    paddingTop: '50%'
  },
  description: {
    textAlign: 'center',
    fontSize: 16,
    color: colors.srTextInput,
    ...typography.lightbold
  }
})
